import React, { useMemo } from "react";
import "../css/ShopingServicesCard.css";

const ShoppingServicesCard = ({ data = [] }) => {
  // 🧠 Find the "Shopping" service object from API response
  const shoppingData = useMemo(
    () => data.find((item) => item.service === "Shopping"),
    [data]
  );

  // 🧾 Extract and fallback values
  const totalOrders = shoppingData?.total_orders || 0;
  const totalRevenue = shoppingData?.total_revenue || 0;
  const ongoingOrders = shoppingData?.ongoing_orders || 0;
  const pendingDeliveries = shoppingData?.pending_deliveries || 0;
  const completedOrders = shoppingData?.completed_orders || 0;
  const topProduct = shoppingData?.top_selling_product || "—";

  return (
    <div className="shopping-service-card">
      <div className="shopping-service-title">Shopping</div>
      <div className="shopping-service-content">
        <div className="shopping-service-row">
          <span className="shopping-service-label">Total Orders</span>
          <span className="shopping-service-colon">:</span>
          <span className="shopping-service-value">{totalOrders}</span>
        </div>

        <div className="shopping-service-row">
          <span className="shopping-service-label">Total Revenue</span>
          <span className="shopping-service-colon">:</span>
          <span className="shopping-service-value">
            ₹{totalRevenue.toLocaleString()}
          </span>
        </div>

        <div className="shopping-service-row">
          <span className="shopping-service-label">Ongoing Orders</span>
          <span className="shopping-service-colon">:</span>
          <span className="shopping-service-value">{ongoingOrders}</span>
        </div>

        <div className="shopping-service-row">
          <span className="shopping-service-label">Pending Deliveries</span>
          <span className="shopping-service-colon">:</span>
          <span className="shopping-service-value">{pendingDeliveries}</span>
        </div>

        <div className="shopping-service-row">
          <span className="shopping-service-label">Completed Orders</span>
          <span className="shopping-service-colon">:</span>
          <span className="shopping-service-value">{completedOrders}</span>
        </div>

        <div className="shopping-service-row">
          <span className="shopping-service-label">Top Selling Product</span>
          <span className="shopping-service-colon">:</span>
          <span className="shopping-service-value">{topProduct}</span>
        </div>
      </div>
    </div>
  );
};

export default ShoppingServicesCard;
